// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_orthohouse_tagline = /** @type {(inputs: {}) => string} */ () => {
	return `Orthopaedic, mobility & home care`
};

const el_orthohouse_tagline = /** @type {(inputs: {}) => string} */ () => {
	return `Ορθοπεδικά, βοηθήματα κινητικότητας & φροντίδα στο σπίτι`
};

const ru_orthohouse_tagline = /** @type {(inputs: {}) => string} */ () => {
	return `Ортопедия, средства реабилитации и уход на дому`
};

const he_orthohouse_tagline = /** @type {(inputs: {}) => string} */ () => {
	return `אורתופדיה, עזרי ניידות וטיפול ביתי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const orthohouse_tagline = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.orthohouse_tagline(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("orthohouse_tagline", locale)
	if (locale === "en") return en_orthohouse_tagline(inputs)
	if (locale === "el") return el_orthohouse_tagline(inputs)
	if (locale === "ru") return ru_orthohouse_tagline(inputs)
	if (locale === "he") return he_orthohouse_tagline(inputs)
	return "orthohouse_tagline"
};